/**
 * @typedef {Object} VideoWidgetStyles
 * @property {0 | 1} thumbnailSize - Способ отображения миниатюр: 0 - вместить, 1 - заполнить
 * @property {0 | 1 | 2} fieldRounding - border-radius
 **/

/**
 * Represents a video widget configuration.
 * @typedef {Object} VideoWidgetConfig
 * @property {number} index - Индекс видео в форме
 * @property { 0 | 1 | 2 } orientationVideo - The orientation of the video. Possible values: 0 (unknown), 1 (horizontal), 2 (vertical).
 * @property {string} preview - The URL of the video preview.
 * @property {number} showLogo - Indicates whether the logo should be shown. Possible values: 0 (no), 1 (yes).
 * @property {string} widgetId - The unique identifier for the widget.
 * @property {string} mainVideo - The URL of the main video.
 * @property {number} id - The unique identifier for the video widget.
 * @property {null|string} userPreviewImg - The URL of the user-provided preview image, or null if not provided.
 * @property {number} showTimeline - Indicates whether the timeline should be shown. Possible values: 0 (no), 1 (yes).
 */
export class VideoItem {
  /**
   * @param {VideoWidgetConfig} widgetData
   * @param {VideoWidgetStyles} widgetStyles
   **/
  constructor(widgetData, widgetStyles) {
    this.index = widgetData.index;
    this.id = widgetData.id;
    this.preview = widgetData.preview;
    this.showLogo = widgetData.showLogo;
    // this.widgetId = widgetData.widgetId;
    this.mainVideo = widgetData.mainVideo;
    this.userPreviewImg = widgetData.userPreviewImg;
    // this.showTimeline = widgetData.showTimeline;

    this.thumbnailSize = widgetStyles.thumbnailSize;
  }
  get HTML() {
    return `
            <video
            id="video_${this.index}"
            class="video-js vjs-theme-city gallery-${this.id} ${this.thumbnailSize ? "qf-g-fill" : "qf-g-contain"}"
            preload="auto"
            width="220"
            height="220"
            poster="${this.userPreviewImg}"
            >
                <source src="${this.mainVideo}" type="application/x-mpegURL" >
            </video>
        `;
  }
}